import axiosService from '@services/axiosService';

export const createUser = (token, email, password) =>
  axiosService.post(`/api/AppUser/?access_token=${token}`, { email, password });

export const deleteUser = (token, id) =>
  axiosService.post(`/api/AppUser/${id}/safe-delete?access_token=${token}`);

export const getUsers = (token) =>
  axiosService.get(
    `/api/AppUser/?filter=${JSON.stringify({
      where: { email: { nlike: encodeURI('archived_%') } },
      include: 'roles',
    })}&access_token=${token}`,
  );

export const updatePermission = (token, userId, role) =>
  axiosService.post(`/api/AppUser/${userId}/update-role?access_token=${token}`, { role });

export const getAdminSettings = (token) =>
  axiosService.get(`/api/Settings?&access_token=${token}`);

export const changeAdminSettings = (token, settings) =>
  axiosService.put(`/api/Settings?access_token=${token}`, settings);

export const forceSync = (token) =>
  axiosService.put(`/api/TranscriptEntries/force-sync?access_token=${token}`);

export const transformSettingsResponse = ({ key, value }) => ({
  [key]: value === 'true',
});
export const transformSettingsArrayToObject = (arr) =>
  arr.reduce(($, item) => ({ ...$, ...transformSettingsResponse(item) }), {});



// WEBPACK FOOTER //
// ./services/admin.js